import { PRICING_OVERRIDE_FIELDS } from '@/graphql/fragments/pricing_overrides';
import { LOCATION_FIELDS } from '@/graphql/queries/locations';
import { SUBREGION_BASE_FIELDS, SUBREGION_FIELDS } from '@/graphql/queries/subregions';
import { SUBREGION_CARRIER_FIELDS } from '@/graphql/queries/subregion_carrier_mappings';
import { gql } from '@apollo/client';

export const QUERY_DELIVERY_PROFILES = gql`
    ${SUBREGION_BASE_FIELDS}
    query GetSubregionsByOrgProfile($query: delivery_profiles_bool_exp!) {
        results: delivery_profiles(where: $query) {
            delivery_profile_id
            organization_id
            name
            subregions {
                ...SubregionBaseFields
            }
        }
    }
`;

export const QUERY_SUBREGIONS_BY_CLIENT = gql`
    ${SUBREGION_FIELDS}
    query GetSubregionsByClient($client_id: uuid) {
        results: subregions(where: { client_id: { _eq: $client_id } }) {
            ...SubregionFields
        }
    }
`;

export const QUERY_CARRIERS = gql`
    query GetCarriers($test: Boolean!) {
        results: clients(
            where: {
                user: { roles: { _has_key: "CARRIER" } }
                test_acc: { _eq: $test }
                deactivated: { _eq: false }
                approved: { _eq: true }
            }
            order_by: { business_name: asc_nulls_last }
        ) {
            client_id
            business_name
            email
            locations {
                location_id
                location_name
                business_address
                business_unit
                business_city
                business_state
                business_zip
            }
        }
    }
`;

export const QUERY_SUBREGIONS_BY_PROFILE = gql`
    ${SUBREGION_FIELDS}
    ${SUBREGION_CARRIER_FIELDS}
    query GetProfileSubregions($profile: String!) {
        results: subregions(where: { type: { _eq: $profile } }) {
            ...SubregionFields
            carriers {
                ...SubregionCarrierFields
            }
        }
    }
`;

export const QUERY_ASSIGN_OVERRIDES = gql`
    ${PRICING_OVERRIDE_FIELDS}
    ${SUBREGION_FIELDS}
    query GetAssignOverrides($test: Boolean!) {
        results: pricing_overrides(
            where: {
                _and: [
                    { oms: { _eq: false } }
                    { enabled: { _eq: true } }
                    { assign_id: { _is_null: false } }
                    { assign: { approved: { _eq: true } } }
                    { assign: { deactivated: { _eq: false } } }
                    { assign: { test_acc: { _eq: $test } } }
                ]
            }
        ) {
            ...PricingOverrideFields
            client {
                client_id
                business_name
            }
            assign {
                client_id
                business_name
            }
        }
    }
`;

export const QUERY_SUBREGIONS_MANY = gql`
    ${SUBREGION_FIELDS}
    ${SUBREGION_CARRIER_FIELDS}
    ${LOCATION_FIELDS}
    query GetSubregionsMany($client_ids: [uuid!]!) {
        results: subregions(
            where: { _and: [{ client_id: { _in: $client_ids } }, { is_resource_zone: { _eq: true } }] }
        ) {
            ...SubregionFields
            carriers(order_by: { is_primary: asc_nulls_last }) {
                ...SubregionCarrierFields
            }
        }
        locations(where: { client_id: { _in: $client_ids } }) {
            ...LocationFields
        }
    }
`;
